import { Injectable } from '@angular/core';
import { BaseServiceService } from '../base_service/base-service.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  URL: string

  constructor(
    private baseService:BaseServiceService, 
    private http:HttpClient
    ) { 
    this.URL = this.baseService.baseUrl();
  }

  // get temp Account number
  getTempAccountNumber(){
    const url_getTempAccount = this.URL + 'customerAccount/accountNumber'
    return  this.http.get(url_getTempAccount);
  }


  // user register - commented
  // registerService(data : any): Observable<any>{
  //   const url_register = this.URL + 'customer/saveCustomerV2'
  //   return this.http.post(url_register,data);
  // }
  // change request 15-09-2022 MS
  registerService(data : any): Observable<any>{
    const url_register = this.URL + 'customer/savePendingMobileCustomerAccount'
    return this.http.post(url_register,data);
  }

  activateCustomerAccount(data: any): Observable<any> {
    const url_activeCus = this.URL + 'customer/activateCustomerAccount';
    const params_getUser = new HttpParams()
      .set('token', data)
      return this.http.get(url_activeCus, {
        responseType: 'json',
        params: params_getUser
      })
  }




  // user login
  loginService(data : any): Observable<any>{
    
    const url_login = this.URL + 'customerAccount/verifyByEmailID'
    const payLoad = new HttpParams()
    .set('pinNumber',data.pinNumber)
    .set('emailId',data.emailId);

    return this.http.post(url_login, payLoad.toString(),{
      headers: new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
    })
  }

  //user login for casino
  loginService_casino(data: any): Observable<any> {
    const url_login = this.URL + 'casino/verifyCasinoByEmailID';
    const payLoad = new HttpParams()
      .set('pinNumber', data.pinNumber)
      .set('emailId', data.emailId);

    return this.http.post(url_login, payLoad.toString(), {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
    });
  }

  // forgot passowrd (Comment the code for use stbet web resetPassword service)
  // forgotPassword(id){
  //   const url_forgotPw = this.URL + 'customerAccount/forgotPin'
  //   const parms_id = new HttpParams()
  //   .set('accountNumber',id)
  //   return  this.http.post(url_forgotPw,parms_id,{
  //     headers: new HttpHeaders()
  //     .set('Content-Type', 'application/json')
  //   });
  // }

  // forgot passowrd with email (Using stbet web project resetpassword)
  forgotPassword(email:string){
    const url_forgotPw = this.URL + 'customerAccount/resetPassword?email='
    return  this.http.get(url_forgotPw+email);
  }


  // log out
  logOutService(){
    
  }

  
}
